import * as actionTypes from "../../../actions/fulfillment/types/wro";

const INITIAL_STATE = {
  fetching: false,
  data: null,
  error: null,
};

export default function (state = INITIAL_STATE, action) {
  const { WRO_LABELS_REQUESTED, WRO_LABELS_SUCCESS, WRO_LABELS_ERRORED } = actionTypes;

  switch (action.type) {
    case WRO_LABELS_REQUESTED:
      return { ...state, fetching: true };
    case WRO_LABELS_SUCCESS:
      return { ...state, fetching: false, data: action.data, error: null };
    case WRO_LABELS_ERRORED:
      return { ...state, fetching: false, data: null, error: action.error };
    default:
      return state;
  }
}
